import React, { Component } from 'react';
import styles from './styles.scss';
import WModal from '../../components/WModal/WModal';
import CONFIG from '../../config';
import http from '../../helpers/http';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import UserInfo from '../../helpers/userinfo';
import { Button } from 'react-bootstrap';

class PaymentPeriod extends Component 
{
  constructor(props){
    super(props);
    this.state = {
      show_spinner:true,
      message:null,
      no_data:false,
      payment_list:[],
      data:{}
    };
  }

  componentDidMount() {

    this.pullData()
  }
  pullData(){

    this.setState({ show_spinner: true });

    http.get(
      CONFIG.API_HOST + 'api/v1.3/payment',
      { }, 
      (state, res) => {
        
        this.setState({ show_spinner: false });
        
        if (state === false) { return this.setState({ message: '發生錯誤' }); }

        if (res.code !== 200) { return this.setState({ message: res.reason }); }

        const { period_payment_list = [], contact = null }= res.data;

        this.setState({
          no_data: period_payment_list.length === 0,
          payment_list: period_payment_list,
          contact:contact
        })
        
        http.post(
          CONFIG.API_HOST + 'api/v1.3/payment/read', 
          { }, 
          (state, res) => 
          {
            //if (state === false) { return console.error('發生錯誤'); }
    
            //if (res.code !== 200) { return console.error(res.reason, res); }
          })
      }
    )
  }
  openModal=()=>{
    this.refs.modal.show();
  }
  onModalClick(title)
  {
    console.log('onModalClick', title)
    const {input_deg} = this.refs;
    
    if (title === '確認')
    {
      
    }
  }
  render()
  {
    const array = [
      {date: '2018-4-16', name: '備證款-房屋', total: 1080000},
      {date: '2018-4-16', name: '備證款-房屋', total: 1080000},
      {date: '2018-4-16', name: '備證款-房屋', total: 1080000},
      {date: '2018-4-16', name: '備證款-房屋', total: 1080000, active: true},
    ]
    const {payment_list =[], contact = null } = this.state;
    var total_amt = 0
    payment_list.forEach((item,idx) => {

      item.amt = parseInt(item.amt, 10) || 0

      total_amt += item.amt

      item.amt_string = item.amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      console.log(item)
    })
    total_amt = total_amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    return (
      <div className={styles.page_container}>
        
        { (this.state.no_data || this.state.message) && 
          <WMask  title={ this.state.message ? this.state.message : ''}>
            { this.state.no_data &&
              <div>
                <h1>目前暫無資料</h1>
              </div>
            }
          </WMask>
        }
        
        <WModal ref="modal" 
          title="系統提示" 
          message="因對帳作業所需，以下帳款於付款完成後3個工作天入帳" 
          btns={['確認']}
          callback={(title) => this.onModalClick(title) }
          onClick={(title) => this.onModalClick(title) }/>


        <div className={styles.page_title}>
          {/*{UserInfo.houseid && UserInfo.houseid.replace(UserInfo.caseid, "")}*/}
          <p>繳款累積</p>
          <h1>{total_amt}</h1>
          <i
            onClick={this.openModal}
          >?</i>
        </div>
        <table>
          <thead>
            <tr>
              <th>最新發票日</th>
              <th>期別</th>
              <th>金額</th>
            </tr>
          </thead>
          <tbody>
            { payment_list.map((item, key)=>{
              return(
                <tr key={key} className={item.active ? 'active' : ''}>
                  <td>{item.exp_date}</td>
                  <td>{item.name}</td>
                  <td>{item.amt_string}</td>
                </tr>
              )
            })
            }
          </tbody>
        </table>
        { contact && ( contact.tel != null || contact.life_tel != null ) &&
          <div className={styles.info_list}>
              <ul>
                <li>此功能已停止更新，如欲查詢請電：</li>
                { contact.tel      && <li style={{color:'#006FBC'}}>遠雄建設：{contact.tel}      分機 {contact.tel_ext}</li> }
                { contact.life_tel && <li style={{color:'#006FBC'}}>遠雄人壽：{contact.life_tel} 分機 {contact.life_tel_ext}</li>}
                <li>將由專人為您協助</li>
              </ul>
          </div>
        }
        
        { this.state.show_spinner && <WMask><WSpinner/></WMask> }
      </div>
    );
  }
}

export default PaymentPeriod;


// WEBPACK FOOTER //
// ./src/views/PaymentPeriod/PaymentPeriod.js